// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3OQOu","text":"SelectPayment_text__3AhPF","title":"SelectPayment_title__1VeU4","btn":"SelectPayment_btn__3-W2R"};